import React, { Component } from 'react';
import styled from 'styled-components';
import SearchResultsContainer from '../SearchPage/SearchResultsContainer';
import RenderLayoutViews from '../shared/RenderLayoutViews';
import MediaQueryHelper from '../../../templates/MediaQueryHelper';
import { apiSearchAlgolia } from '../../../../lib/apiQueries';

const SearchPageContainerDiv = styled.div`
  margin: ${p => p.theme.unit(8)} 0 0 0;
`;

const MobileSearchPageContainerDiv = styled.div`
  margin: ${p => p.theme.unit(4)} 0 0 0;
`;

class SearchContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      shopHitsData: [],
      categoryHitsData: [],
      totalNumberOfHits: null,
    };
  }

  componentWillMount() {
    const {
      searchQuery,
      locale
    } = this.props;

    apiSearchAlgolia(searchQuery, {}, 'shops', locale)
      .then(content => {
        this.setState({
          shopHitsData: content.hits,
        });

        return content.nbHits;
      })
      .then(initialTotalNumber => apiSearchAlgolia(searchQuery, {}, 'categories', locale)
        .then(content => {
          this.setState({
            categoryHitsData: content.hits,
            totalNumberOfHits: initialTotalNumber + content.nbHits,
          });
        })
      )
      .catch(err => console.error(err));
  }

  render() {
    const {
      searchPageData,
      searchNavBarData,
      searchQuery,
      locale,
      userData,
      pageStateModifiers,
    } = this.props;

    const layout = searchPageData && searchPageData.layout ? searchPageData.layout : [];
    const SearchPageContent = () => {
      return (
        <div>
          <SearchResultsContainer
            shopHits={this.state.shopHitsData}
            categoryHits={this.state.categoryHitsData}
            searchNavBarData={searchNavBarData}
            searchPageData={searchPageData}
            totalNumberOfHits={this.state.totalNumberOfHits}
            searchQuery={searchQuery}
            locale={locale}
            userData={userData}
            pageStateModifiers={pageStateModifiers}
          />
          <RenderLayoutViews
            views={layout}
            locale={locale}
            userData={userData}
            pageStateModifiers={pageStateModifiers} />
        </div>
      );
    };

    const DesktopBody = () => (
      <SearchPageContainerDiv>
        <SearchPageContent />
      </SearchPageContainerDiv>
    );

    const MobileBody = () => (
      <MobileSearchPageContainerDiv>
        <SearchPageContent />
      </MobileSearchPageContainerDiv>
    );

    const renderComp = (
      <MediaQueryHelper
        desktopChildren={DesktopBody()}
        mobileChildren={MobileBody()} />);
    return renderComp;
  }
}

export default SearchContent;
